import { createFsCockpitAuthedAxiosInstance } from "./axiosFsCockpitAuthAdapter";
import { Language } from "features/i18n/translations";

const WINE_MENU_API_BASE_URL = process.env.REACT_APP_WINE_MENU_BACKEND_BASE_URL;

const fsCockpitAuthedAxiosInstance = createFsCockpitAuthedAxiosInstance({
    baseURL: WINE_MENU_API_BASE_URL
});

export interface AperitifPresetMetadata {
    namede: string;
    createdby: string;
}

export interface AperitifPresetBody {
    name: { [lang: string]: string };
    imageUrl: string|undefined;
    description: { [lang: string]: string };
    size: string;
    price: string;
}

export interface AperitifPresetValues {
    name: string;
    description: string;
    size: string;
    price: string;
    imageUrl: string|undefined;
}

export const emptyAperitifPreset = ():AperitifPresetBody => ({
    name: {},
    imageUrl: undefined,
    description: {},
    size: "",
    price: ""
})

export function aperitifBodyToForm(body: AperitifPresetBody, activeLang: Language):AperitifPresetValues {
    return {
        name: body.name?.[activeLang] ?? "",
        description: body.description?.[activeLang] ?? "",
        size: body.size,
        price: body.price,
        imageUrl: body.imageUrl,
    };
}

export interface AperitifPreset {
    id: string;
    metadata: AperitifPresetMetadata;
    lastModifiedAt: Date;
    body: AperitifPresetBody;
}

export type ListAperitifPresetsResponse = AperitifPreset[];

export type GetAperitifPresetResponse = AperitifPreset;

export interface CreateAperitifPresetRequest {
    body: any;
}

export type CreateAperitifPresetResponse = AperitifPreset;

export interface UpdateAperitifPresetRequest {
    presetId: string;
    body: any;
}

export type UpdateAperitifPresetResponse = AperitifPreset;


async function listAperitifPresets(): Promise<ListAperitifPresetsResponse> {
    const response = await fsCockpitAuthedAxiosInstance.request({
        method: 'GET',
        url: '/aperitif-presets',
        responseType: 'json'
    });
    return response.data as ListAperitifPresetsResponse;
}

async function getAperitifPreset(presetId: string): Promise<GetAperitifPresetResponse> {
    const response = await fsCockpitAuthedAxiosInstance.request({
        method: 'GET',
        url: `/aperitif-presets/${presetId}`,
        responseType: 'json'
    });
    return response.data as GetAperitifPresetResponse;
}

async function createAperitifPreset(request: CreateAperitifPresetRequest): Promise<CreateAperitifPresetResponse> {
    const response = await fsCockpitAuthedAxiosInstance.request({
        method: 'POST',
        url: '/aperitif-presets',
        data: request.body,
        responseType: 'json'
    });
    return response.data as CreateAperitifPresetResponse;
}

async function updateAperitifPreset(request: UpdateAperitifPresetRequest): Promise<UpdateAperitifPresetResponse> {
    const response = await fsCockpitAuthedAxiosInstance.request({
        method: 'PUT',
        url: `/aperitif-presets/${request.presetId}`,
        data: request.body,
        responseType: 'json'
    });
    return response.data as UpdateAperitifPresetResponse;
}

async function deleteAperitifPreset(presetId: string): Promise<void> {
    await fsCockpitAuthedAxiosInstance.request({
        method: 'DELETE',
        url: `/aperitif-presets/${presetId}`
    });
}

export const aperitifMenuApi = {
    listAperitifPresets,
    getAperitifPreset,
    createAperitifPreset,
    updateAperitifPreset,
    deleteAperitifPreset
};
